import { observable, reaction, action, computed } from "mobx";
import { registrationStore, usersStore, translationsStore } from '../../../stores';
import { api } from "../../../services";

class Step_4 {
  @observable slimpayHtml;
  @observable inProgress = false;

  constructor(registrationStore, usersStore, translationsStore) {
    this.registrationStore = registrationStore;
    this.usersStore = usersStore;
    this.translationsStore = translationsStore;

    this.registrationStore.formValues.step_4 = {};

    reaction(
      () => this.paymentType,
      paymentType => {
        if (this.paymentType && this.paymentType === "SEPA") {
          api({ action: "create slimpay mandate" }, this.user).then(result => {
            action((this.slimpayHtml = result));
          }).catch(error => {
            action((this.slimpayHtml = this.mandateCreationErrorMessage(error)));
          });
        }
      }
    );
  }

  @computed
  get user() {
    return this.registrationStore.user;
  }

  @computed
  get formValues() {
    return registrationStore.formValues.step_4;
  }

  @action
  setMyPosition() {
    this.registrationStore.setPosition(4);
  }

  @computed
  get session() {
    return this.registrationStore.session;
  }

  @computed
  get subscription() {
    try {
      if (this.user) {
        return this.user.assets[0].subscription;
      }
    } catch (error) {
      console.log("error getting subscription");
    }
  }

  createNextStatus() {
    if (this.registrationStore.subscription.status === 4) {
      return Object.assign({}, this.registrationStore.subscription, { status: 5 }, { paymentChecked: true });
    }
    if (this.registrationStore.subscription.status > 4) {
      return Object.assign({}, this.registrationStore.subscription, { paymentChecked: true });
    }
  }

  updateSubscription(subscription) {
    return api({ action: "update asset" }, this.registrationStore.session, this.registrationStore.assetId, {
      subscription
    }).then(updatedAsset => {
      this.registrationStore.setUserAsset(updatedAsset);
      this.usersStore.addOrModify(this.registrationStore.user);
      this.registrationStore.setSession(this.registrationStore.user._id);
      return {};
    });
  }

  @computed
  get paymentType() {
    if (this.subscription) {
      const ratePlan = this.subscription.zuoraRecurringRatePlan
        ? "zuoraRecurringRatePlan"
        : this.subscription.zuoraOneTimeRatePlan
          ? "zuoraOneTimeRatePlan"
          : null;
      if (ratePlan) {
        try {
          if (this.subscription[ratePlan].paymentType) {
            return this.subscription[ratePlan].paymentType.pageType;
          } else {
            console.error(`no payment type defined for ${ratePlan}`);
          }
        } catch (e) {
          console.error("error getting payment type", e);
        }
      } else {
        return undefined;
      }
    }
  }

  @computed
  get isPaymentExternal() {
    return this.paymentType === "Other" || this.paymentType === "Bonifico" || this.paymentType === "Cash";
  }

  @action
  setFormField(field, value) {
    this.registrationStore.setFormField("step_4", field, value);
  }

  mandateCreationErrorMessage = (error) => {
    return `<div>${this.translationsStore.current['registration_4']['errorMandateCreation']}</div><!-- error: ${JSON.stringify(error)} -->`;
  };
}

export default new Step_4(registrationStore, usersStore, translationsStore);



// WEBPACK FOOTER //
// ./src/stores/registrationStore/steps/step_4.js